module.exports = __webpack_public_path__ + "img/en.305c3149.webp";